import {
  CheckCircleOutlined,
  StarOutlined,
  WhatsAppOutlined
} from "@ant-design/icons"
import { Flex, Modal, Typography } from "antd"
import React from "react"

const { Title, Text } = Typography

interface SuccessConnectionPopupProps {
  onClose: () => void
}

export const SuccessConnectionPopup = ({
  onClose
}: SuccessConnectionPopupProps) => {
  return (
    <Modal
      open
      onCancel={onClose}
      footer={null}
      centered
      width={500}
      closable={false}
      className="success-modal"
      styles={{
        body: { padding: "40px 32px" }
      }}
    >
      <Flex vertical align="center" gap="large">
        {/* Celebration Icon */}
        <div className="relative">
          <div className="w-24 h-24 bg-gradient-to-br from-green-400 via-green-500 to-emerald-600 rounded-full flex items-center justify-center shadow-xl">
            <CheckCircleOutlined className="text-white text-5xl" />
          </div>
          <div className="absolute -top-1 -right-1 w-10 h-10 bg-gradient-to-r from-yellow-400 animate-pulse to-orange-500 rounded-full flex items-center justify-center border-4 border-white shadow-lg">
            <StarOutlined className="text-white text-lg" />
          </div>
          <div className="absolute -bottom-2 -left-2 w-12 h-12 bg-gradient-to-r from-green-500 to-green-600 rounded-full flex items-center justify-center border-4 border-white shadow-lg">
            <WhatsAppOutlined className="text-white text-xl" />
          </div>
        </div>

        {/* Welcome Message */}
        <Flex vertical align="center" gap="medium">
          <Title level={1} className="!mb-0">
            🎉 Congratulations!
          </Title>

          <Title level={3}>WhatsApp Successfully Connected to EZBuild</Title>

          <Text type="secondary" className="text-center text-lg  max-w-md">
            You&lsquo;ve just taken an important step towards automating your
            business! Now you can manage you processes from one place.
          </Text>
        </Flex>

        {/*/!* Welcome Benefits *!/*/}
        {/*<div className="w-full bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl p-6 border border-green-100">*/}
        {/*  <Text className="text-lg font-semibold text-green-800 mb-4 block text-center">*/}
        {/*    🚀 What's next:*/}
        {/*  </Text>*/}
        {/*  <Space direction="vertical" size="medium" className="w-full">*/}
        {/*    <div className="flex items-start gap-4 p-3 bg-white rounded-xl shadow-sm">*/}
        {/*      <div className="w-3 h-3 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full mt-1 flex-shrink-0"></div>*/}
        {/*      <div>*/}
        {/*        <Text className="font-medium text-gray-800 block">*/}
        {/*          Automated Workflows*/}
        {/*        </Text>*/}
        {/*        <Text className="text-sm text-gray-600">*/}
        {/*          Set up smart replies and automatic messages*/}
        {/*        </Text>*/}
        {/*      </div>*/}
        {/*    </div>*/}

        {/*    <div className="flex items-start gap-4 p-3 bg-white rounded-xl shadow-sm">*/}
        {/*      <div className="w-3 h-3 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full mt-1 flex-shrink-0"></div>*/}
        {/*      <div>*/}
        {/*        <Text className="font-medium text-gray-800 block">*/}
        {/*          Instant Customer Connection*/}
        {/*        </Text>*/}
        {/*        <Text className="text-sm text-gray-600">*/}
        {/*          Respond faster and maintain constant contact*/}
        {/*        </Text>*/}
        {/*      </div>*/}
        {/*    </div>*/}

        {/*    <div className="flex items-start gap-4 p-3 bg-white rounded-xl shadow-sm">*/}
        {/*      <div className="w-3 h-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full mt-1 flex-shrink-0"></div>*/}
        {/*      <div>*/}
        {/*        <Text className="font-medium text-gray-800 block">*/}
        {/*          Unified Dashboard*/}
        {/*        </Text>*/}
        {/*        <Text className="text-sm text-gray-600">*/}
        {/*          All messages and contacts in one convenient place*/}
        {/*        </Text>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </Space>*/}
        {/*</div>*/}
      </Flex>
    </Modal>
  )
}
